export const ka = {
  title: 'ხის საფარის სიმაღლე',
  subtitle: '2000/2020, 30 m, global, UMD/NASA GEDI',
  download_data: '',
  learn_more: 'https://glad.umd.edu/dataset/gedi/',
  content: [
    {
      label: 'ფუნქცია',
      value: 'აჩვენეთ გლობალური ტყის ტილოების სიმაღლე 2000 და 2020 წლებში.',
    },
    {
      label: 'რეზოლუცია',
      value: '30 მეტრი',
    },
    {
      label: 'გეოგრაფიული გაშუქება',
      value: 'გლობალური, პროტოტიპის მონაცემებით 52 ° N- ზე მეტი',
    },
    {
      label: 'წყარო',
      value:
        'Potapov, P., Li, X., Hernandez-Serna, A., Tyukavina, A., Hansen, M.C., Kommareddy, A., Pickens, A., Turubanova, S., Tang, H., Silva, C.E. and Armston, J., 2021. Mapping global forest canopy height through integration of GEDI and Landsat data. Remote Sensing of Environment, 253, p.112165. https://doi.org/10.1016/j.rse.2020.112165',
    },
    {
      label: 'სიხშირე',
      value: '',
    },
    {
      label: 'შინაარსის თარიღი',
      value: '2000 და 2020',
    },
    {
      label: 'გაფრთხილება',
      value:
        'ტყის სიმაღლის გლობალური რუკა არის პროტოტიპის პროდუქტი, რომელსაც აქვს ცნობილი GEDI მონაცემთა ხარისხთან და Landsat მონაცემთა ხელმისაწვდომობასთან დაკავშირებული საკითხები. GEDI-ს მონაცემები გადაჭარბებულია ტყის სიმაღლეზე ფერდობებზე ზომიერი და სუბტროპიკული მთის ბალახებში, მაგალითად ახალ ზელანდიასა და ლესოტოში. ხე სიმაღლე ქალაქებსა და გარეუბნებში შეიძლება დაფუძნდეს შენობის სიმაღლით, რადგან GEDI მონაცემები არ წარმოადგენს დისკრიმინაციას მცენარეულობისა და ადამიანის მიერ შექმნილი ობიექტების სიმაღლეს შორის. GEDI დაკალიბრების გაურკვევლობები (კერძოდ, გეოლოკაციის სიზუსტე და მიწის ზედაპირის სიმაღლის შეფასება) შეიძლება იყოს პასუხისმგებელი რუკის ზოგიერთ შეცდომაზე. ხის სიმაღლის მოდელი გაჯერებულია 30 მ-ზე ზემოთ და შეიძლება არ წარმოადგენდეს უმაღლესი ხეების სიმაღლეს. გლობალური პროდუქტი მომავალში განახლდება პრობლემების უმეტესობის გადასაჭრელად.',
    },
    {
      label: 'ლიცენზია',
      value: '',
    },
  ],
  overview: {
    label: 'მიმოხილვა',
    value:
      'ახალი, 30 მ სივრცითი რეზოლუციის გლობალური ტყის ტილოების სიმაღლის რუკა შემუშავდა გლობალური ეკოსისტემის დინამიკის გამოძიების (GEDI) ლიდარი ტყის სტრუქტურის გაზომვებისა და Landsat ანალიზის მზა მონაცემთა დროის სერიების ინტეგრაციით. NASA GEDI არის კოსმოსური ლიდარის ინსტრუმენტი, რომელიც ოპერირებს საერთაშორისო კოსმოსურ სადგურზე 2019 წლის აპრილიდან. იგი უზრუნველყოფს მცენარეული სტრუქტურის წერტილზე დაფუძნებულ გაზომვებს, მათ შორის ტყის ტილოების სიმაღლეს 52 ° N და 52 ° S გლობალურად. მერილენდის უნივერსიტეტის გლობალური მიწის ანალიზისა და აღმოჩენის გუნდმა (UMD GLAD) ინტეგრირებული GEDI მონაცემები დღემდე (2019 წლის აპრილი-ოქტომბერი) 2019 წლის Landsat ანალიზისთვის მზად დროის სერიების მონაცემებით (Landsat ARD). GEDI RH95 (ნათესავი სიმაღლე 95%) მეტრული გამოიყენებოდა მოდელის დაკალიბრებაზე. Landsat მრავალ დროებითი მეტრიკა, რომელიც წარმოადგენს ზედაპირულ ფენოლოგიას, წარმოადგენს ტყის სიმაღლის გლობალური მოდელირების დამოუკიდებელ ცვლადებს. "მოძრავი ფანჯარა" ადგილობრივად დაკალიბრებული და გამოყენებითი რეგრესიის ხის ანსამბლის მოდელი განხორციელდა ტყის სიმაღლის პროგნოზირებისა და გლობალური რუკის თანმიმდევრულობის მაღალი ხარისხის უზრუნველსაყოფად. მოდელი ექსტრაპოლირებული იყო ბორეალურ რეგიონებში (GEDI მონაცემთა დიაპაზონის მიღმა), ტყის სიმაღლის პროტოტიპის გლობალური რუკის შესაქმნელად.',
  },
  citation: {
    label: 'ციტატა',
    value:
      'Potapov, P., Li, X., Hernandez-Serna, A., Tyukavina, A., Hansen, M.C., Kommareddy, A., Pickens, A., Turubanova, S., Tang, H., Silva, C.E. and Armston, J., 2021. Mapping global forest canopy height through integration of GEDI and Landsat data. Remote Sensing of Environment, 253, p.112165. https://doi.org/10.1016/j.rse.2020.112165. Accessed through Global Forest Watch on 14/02/2025. www.globalforestwatch.org.',
  },
};
